import { render, staticRenderFns } from "./TrainingHistory.vue?vue&type=template&id=2617bac0&scoped=true&"
import script from "./TrainingHistory.vue?vue&type=script&lang=js&"
export * from "./TrainingHistory.vue?vue&type=script&lang=js&"
import style0 from "./TrainingHistory.vue?vue&type=style&index=0&id=2617bac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2617bac0",
  null
  
)

export default component.exports